"use strict";

const { isString } = require("./strings");

function isTrue(value) {
  return isString(value) ? ["true", "1"].includes(value) : !!value;
}

module.exports = {
  isTrue
};
